import React from 'react';
import { useNavigate } from 'react-router-dom';

const LOGO_BASE = '/images/brands/';

const POPULAR_MAKES = [
  'Toyota', 'Honda', 'BMW', 'Mercedes', 'Audi',
  'Ford', 'Chevrolet', 'Nissan', 'Hyundai', 'Kia',
  'Volkswagen', 'Lexus',
];

const PopularMakesGrid: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="bmm-makes-grid">
      {POPULAR_MAKES.map(make => (
        <a
          key={make}
          className="bmm-make-item"
          href="#"
          onClick={e => { e.preventDefault(); navigate(`/mysearch?make=${encodeURIComponent(make)}`); }}
        >
          <div className="bmm-make-avatar">
            <img
              src={`${LOGO_BASE}${make.toLowerCase()}.png`}
              alt={make}
              onError={e => {
                const el = e.currentTarget;
                el.style.display = 'none';
                if (el.parentElement) el.parentElement.textContent = make[0].toUpperCase();
              }}
            />
          </div>
          <span className="bmm-make-name">{make}</span>
        </a>
      ))}
    </div>
  );
};

export default PopularMakesGrid;
